<script setup lang="ts">
import { loadOnBeforeMount } from '@utils/load-util.ts';
import apiClient from '@src/api/api-client.ts';
import { ref } from 'vue';
import VerticalAlignChildrenWrapper from '@components/layout-wrapper/vertical-align-children-wrapper.vue';
import Text from '@components/text.vue';
import dateTimeUtil from '@utils/date-time-util.ts';

const props = defineProps<{
    idStockReservation: number,
}>();

interface PickQueue {
    isPrio: boolean,
    createdAt: string,
}
const pickQueue = ref<PickQueue|null>(null);
loadOnBeforeMount(async () => {
    pickQueue.value = (await apiClient.get('/be/pick-info/pick-queue-by-reservation/' + props.idStockReservation)).data;
});
</script>

<template>
    <VerticalAlignChildrenWrapper v-if="pickQueue">
        <Text gap="1">Auf der Pick-Queue seit: {{ dateTimeUtil.formatDatetimeToView(pickQueue.createdAt) }}</Text>
        <Text v-if="pickQueue.isPrio" gap="1">Prio</Text>
    </VerticalAlignChildrenWrapper>
</template>
